import * as actionTypes from "../actions/actionTypes";
import { roles } from "../../libs/jsonParsers/roles";

import { updateObject } from "../utility";

const initialState = {
  currentRole: "Select Your Role",
  currentTxtRole: "Select Your Role",
  EXISTING_ROLES: [
    {
      English: "Select Your Role",
    },
    ...roles,
  ],
};

const choose_role = (state, action) => {
  const arrOfRoles = state.EXISTING_ROLES;
  let index;

  arrOfRoles.find(function (obj, idx) {
    if (obj.English === action.role) {
      index = idx;
    }

    return;
  });

  // console.log(arrOfRoles);

  return updateObject(state, {
    currentRole: action.role,
    currentTxtRole: arrOfRoles[index],
  });
};

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.CHOOSE_ROLE) {
    return choose_role(state, action);
  }
  return state;
};

export default reducer;
